<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="page_3"></a><span class="bold">Contents</span></h1>
<h2 class="tocc1"><a href="#/xhtml/04_Chapter01"><span class="bold">Chapter One</span></a></h2>
<h2 class="toc"><a href="#/xhtml/04_Chapter01"><span class="bold">Prelude to the Final Solution</span></a></h2>
<h3 class="toc"><a href="#/xhtml/04_Chapter01#ch1_1">Chełmno (Kulmhof) – Killing Centre</a></h3>
<h3 class="toc"><a href="#/xhtml/04_Chapter01#ch1_2">Majdanek – Labour &amp; Extermination Camp</a></h3>
<h3 class="toc"><a href="#/xhtml/04_Chapter01#ch1_3">Auschwitz-Birkenau – Labour &amp; Extermination Camp</a></h3>
<h2 class="tocc1"><span href="#/xhtml/05_Chapter02" title="Link target outside of Sample"><span class="bold">Chapter Two</span></span></h2>
<h3 class="toc"><span href="#/xhtml/05_Chapter02" title="Link target outside of Sample"><span class="bold">The Reinhard Camps</span></span></h3>
<h3 class="toc"><span href="#/xhtml/05_Chapter02#ch2_1" title="Link target outside of Sample">Belzec</span></h3>
<h3 class="toc"><span href="#/xhtml/05_Chapter02#ch2_2" title="Link target outside of Sample">Sobibor</span></h3>
<h3 class="toc"><span href="#/xhtml/05_Chapter02#ch2_3" title="Link target outside of Sample">Treblinka</span></h3>
<h2 class="tocc1"><span href="#/xhtml/06_Chapter03" title="Link target outside of Sample"><span class="bold">Chapter Three</span></span></h2>
<h3 class="toc"><span href="#/xhtml/06_Chapter03" title="Link target outside of Sample"><span class="bold">Last Years</span></span></h3>
<h2 class="tocc1"><span href="#/xhtml/07_Appendix" title="Link target outside of Sample"><span class="bold">Appendix I</span></span></h2>
<h3 class="toc"><span href="#/xhtml/07_Appendix" title="Link target outside of Sample"><span class="bold">The Main Polish Death Camps</span></span></h3>
<p class="content">The views or opinions expressed in this book and the context in which the images are used do not necessarily reflect the views or policy of, nor imply approval or endorsement by, the United States Holocaust Memorial Museum (USHMM)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?49e1e901